<ng-container *ngFor="let i of [].constructor(numberOfLoadingElements)">
  <div class="loading-wrapper">
    <div class="avatar"></div>
    <div class="animating-lines">
      <div class="line async-1"></div>
      <div class="line async-2"></div>
    </div>
  </div>
</ng-container>
